import React from 'react'
import { useNavigate } from 'react-router-dom';

export const MenuDayOption = () => {

  const navigate = useNavigate();

  

  const handleClickOnline = () => {
    navigate("/vermenuonline")
  }
  
  const handleClickPdf = () => {
    window.open("https://static.enjoysushi.es/assert/pdf/carta-enjoysushi-mediodia.pdf");
  }
  return (
    <div className="flex flex-column flex-wrap" style={{
        backgroundColor: '#FFF',
        color: '#16213D',
        width: '98%',
        marginLeft: '1%',
        marginTop: '1%',
    }}>
      <div className="flex flex-column" style={{            
          margin: '20px',            
          justifyContent: 'center',
          alignItems: 'center',
      }}>          
        <h1> MENU ENJOY </h1>
        <span style={{
          fontSize: '20px',
        }}>Mediodia no festivo</span>
      </div>

      <div className="flex flex-column flex-wrap">
        <div className="flex flex-row justify-content-center" style={{
          paddingBottom: '50px'
        }}> 
          <div className="flex flex-column m-2" style={{
              backgroundColor: '#16213D',
              borderRadius: '75px',
              height: '150px',
              width: '150px',
            }} onClick={()=> handleClickOnline()}>
              <div className="flex" style={{
                justifyContent: 'center',
                marginTop: '35px',
                width: '100%',
                fontSize: '25px',
                fontWeight: 'bold',
                color: '#FFF',
              }}>
                <span>Ver menu online</span>                
              </div>

          </div>
          <div className="flex flex-column m-2" style={{
              backgroundColor: '#16213D',
              borderRadius: '75px',
              height: '150px',
              width: '150px',
            }} onClick={()=> handleClickPdf()} >
              <div className="flex" style={{
                justifyContent: 'center',
                marginTop: '35px',
                width: '100%',
                fontSize: '25px',
                fontWeight: 'bold',
                color: '#FFF',
              }}>
                <span>Ver menu pdf</span>                
              </div>
          </div>
        </div>             
      </div>
    </div>
  )
}
